module.exports = __webpack_public_path__ + "static/img/fabrication_1.f92c98c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrication_1.jpg
// module id = 9Vsg
// module chunks = 0